// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"229":"config","857":"report","962":"home","966":"login"}[chunkId] + "." + {"229":"9c18bc33","857":"2c964ad6","962":"9c549ca7","966":"32c2920c"}[chunkId] + ".css";
};